// assets/_animation.lenis.js
(async()=>  {
    const { default: Lenis } = await import('https://cdn.jsdelivr.net/npm/lenis@1.3.21/+esm');
  if (typeof Lenis === "undefined"){
    console.log("Lenis has not been loaded yet !"); 
    return;
  }
  const lenis = new Lenis({
    lerp: 0.03,
    duration: 2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    orientation: "vertical",
    gestureOrientation: "vertical",
    smoothWheel: true,
    syncTouch: false,
    syncTouchLerp: 0.075,
    wheelMultiplier: 1,
    touchMultiplier: 2,
    infinite: false,
  });
  if (typeof gsap !== "undefined") {
    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });
  }
  const isGloballyLocked = () => {
    return (
      document.body.style.overflow === "hidden" ||
      document.body.style.overflowY === "hidden" ||
      document.documentElement.style.overflow === "hidden" ||
      document.documentElement.style.overflowY === "hidden" ||
      document.body.classList.contains("overflow-hidden") ||
      document.documentElement.classList.contains("overflow-hidden")
    );
  };
  const handleWheel = (e) => {
    if (isGloballyLocked()) {
      lenis.stop();
      return;
    }

    let element = e.target;

    while (element && element !== document.body) {
      const hasScroll = element.scrollHeight > element.clientHeight;
      const isScrollable =
        hasScroll && element.hasAttribute("data-lenis-prevent");

      if (isScrollable) {
        const isAtTop = element.scrollTop === 0;
        const isAtBottom =
          Math.abs(
            element.scrollHeight - element.clientHeight - element.scrollTop
          ) < 1;

        if (
          (e.deltaY < 0 && !isAtTop) ||
          (e.deltaY > 0 && !isAtBottom)
        ) {
          lenis.stop();
          return;
        }
      }

      element = element.parentElement;
    }

    lenis.start();
  };

  window.addEventListener("wheel", handleWheel, { passive: true });

  const checkScrollLock = () => {
    if (isGloballyLocked()) {
      lenis.stop();
    } else {
      lenis.start();
    }
  };
  const observer = new MutationObserver(checkScrollLock);
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ["style", "class"],
  });
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["style", "class"],
  });
  checkScrollLock();
})();